import { createContext } from "react";

/**
 * Where a section's screen puts its primary action — "New contact" — in the
 * page header beside Export (#637), instead of a row of its own above the
 * list. `SectionPage` provides the element; `SectionAction` portals into it.
 * Null outside a section, or before the header has rendered.
 */
export const SectionActionsContext = createContext<HTMLElement | null>(null);
